module.exports = __webpack_public_path__ + "img/link.04a5b3d1.svg";